'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ExpiredEstimate = function ExpiredEstimate(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }), React__default["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M15.8219 2.9375H20.0009C21.0999 2.9375 21.9999 3.7815 21.9999 4.8115V19.8085C21.9999 20.8395 21.0999 21.6835 20.0009 21.6835H12.9999V19.8085H20.0009V4.8115H18.0009V7.6235H8.00391V4.8115H6.00391V9.9985H4.00391V4.8125C4.00391 3.7815 4.90391 2.9375 6.00391 2.9375H10.1839C10.6039 1.8495 11.7039 1.0625 13.0029 1.0625C14.3029 1.0625 15.4019 1.8505 15.8219 2.9375ZM12.0029 3.8745C12.0029 4.3895 12.4539 4.8115 13.0029 4.8115C13.5539 4.8115 14.0019 4.3905 14.0019 3.8745C14.0019 3.3585 13.5539 2.9365 13.0029 2.9365C12.4539 2.9365 12.0029 3.3585 12.0029 3.8745Z",
    fill: "#616161"
  }), React__default["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7 11C3.682 11 1 13.682 1 17C1 20.318 3.682 23 7 23C10.318 23 13 20.318 13 17C13 13.682 10.318 11 7 11ZM10 19.154L9.154 20L7 17.846L4.846 20L4 19.154L6.154 17L4 14.846L4.846 14L7 16.154L9.154 14L10 14.846L7.846 17L10 19.154Z",
    fill: "#616161"
  }));
};

var ExpiredEstimate$1 = iconStyles()(ExpiredEstimate);

module.exports = ExpiredEstimate$1;
